import React from 'react';
import PropTypes from 'prop-types';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {EncodingDatacentersFilter} from '@utils/commonFilters/EncodingDatacentersFilter';

const SdiOriginEntryPointsFilters = ({
    data: {
        encodingDatacenters = [],
    },
    loading,
    filters,
    restoreFilterValues,
}) => (
    <div className='sdiOriginEntryPoints__filters filter__controls__container'>
        <SearchFilter
            loading={loading}
            filters={filters.sdiOriginEntryPoints}
            restoreFilterValues={restoreFilterValues}
        />
        <EncodingDatacentersFilter
            encodingDatacenters={encodingDatacenters}
            loading={loading}
            filters={filters.sdiOriginEntryPoints}
            restoreFilterValues={restoreFilterValues}
        />
    </div>
);

SdiOriginEntryPointsFilters.propTypes = {
    data: PropTypes.shape({
        encodingDatacenters: PropTypes.array,
    }),
    loading: PropTypes.bool.isRequired,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(SdiOriginEntryPointsFilters, {name: 'sdiOriginEntryPoints'});
